import React, { forwardRef } from "react";
import {
  Mic,
  Video,
  Clapperboard,
  Camera,
  Film,
  Languages,
  Briefcase,
  Headphones,
  Radio,
  Music,
  Podcast,
  Speaker,
  MessageSquare,
  Volume2,
  PlayCircle,
  Monitor,
  Tv,
  Theater,
  Megaphone,
  Globe,
  BookOpen,
  Palette,
  PenTool,
  Image,
  Aperture,
  LucideIcon,
} from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

// Available icons for service categories
export const SERVICE_ICONS: Record<string, LucideIcon> = {
  Mic,
  Video,
  Clapperboard,
  Camera,
  Film,
  Languages,
  Briefcase,
  Headphones,
  Radio,
  Music,
  Podcast,
  Speaker,
  MessageSquare,
  Volume2,
  PlayCircle,
  Monitor,
  Tv,
  Theater,
  Megaphone,
  Globe,
  BookOpen,
  Palette,
  PenTool,
  Image,
  Aperture,
};

// Helper to get icon component by name
export const getIconByName = (name: string): LucideIcon => {
  return SERVICE_ICONS[name] || Briefcase;
};

interface IconSelectorProps {
  value: string;
  onChange: (iconName: string) => void;
  className?: string;
}

const IconSelector = forwardRef<HTMLButtonElement, IconSelectorProps>(
  ({ value, onChange, className }, ref) => {
    const IconComponent = getIconByName(value);

    return (
      <Select value={value || "Briefcase"} onValueChange={onChange}>
        <SelectTrigger ref={ref} className={cn("w-full", className)}>
          <SelectValue>
            <div className="flex items-center gap-2">
              <IconComponent size={18} />
              <span>{value || "Briefcase"}</span>
            </div>
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="max-h-[300px] z-50 bg-popover">
          {Object.entries(SERVICE_ICONS).map(([name, Icon]) => (
            <SelectItem key={name} value={name}>
              <div className="flex items-center gap-2">
                <Icon size={18} />
                <span>{name}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }
);

IconSelector.displayName = "IconSelector";

export default IconSelector;
